import { cn } from '@/lib/utils'
import logoMobile from 'assets/logo.svg'
import textoLogo from 'assets/ponto-agil-texto.svg'
import { useBackendMenu } from 'hooks'
import { useAuth } from 'hooks/useAuth'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { MenuResponsivo } from 'templates/Menu/MenuResponsivo'
import { Button } from '../Button'
import { ToggleTheme } from '../ToggleTheme'
import ProfileMenu from './atoms/ProfileMenu'

export function AppNavbar() {
    const navigate = useNavigate()
    const menu = useBackendMenu()
    const user = useAuth()
    const categoria = user?.decoded?.categoria
    const diasAvaliacao = Number(user?.decoded?.diasAvaliacao ?? null)
    if (!user.auth) return null

    if (location.pathname === '/ajuda/atendimento-online')
        return (
            <div className="w-screen flex flex-end h-16">
                <div className="flex-1" />
                <ToggleTheme />
            </div>
        )

    return (
        <div
            className={cn(
                'bg-primary/90 dark:bg-foreground text-accent-foreground',
                'static top-0 z-5 flex h-16 w-full items-center justify-center px-4 shadow-sm',
            )}
        >
            <div className="max-w-[1500px] w-screen mx-auto min-h-0! flex items-center px-4">
                <a
                    className={cn(
                        'font-bold uppercase text-2xl whitespace-nowrap gap-x-2 flex items-center',
                        '[&_img]:max-w-full [&_img]:h-auto [&_img]:align-middle [&_img]:block',
                        'mr-1 cursor-pointer',
                    )}
                    onClick={() => navigate('/')}
                >
                    <div className="size-8 overflow-hidden">
                        <img
                            src={logoMobile}
                            alt="logo"
                            loading="lazy"
                            style={{
                                // white
                                filter: 'invert(88%) sepia(100%) saturate(0%) hue-rotate(35deg) brightness(106%) contrast(101%)',
                            }}
                        />
                    </div>
                    <span className="w-26 hidden sm:flex">
                        <img
                            src={textoLogo}
                            alt="PONTO ÁGIL"
                            loading="lazy"
                            style={{
                                // white
                                filter: 'invert(88%) sepia(100%) saturate(0%) hue-rotate(35deg) brightness(106%) contrast(101%)',
                            }}
                        />
                    </span>
                    <span className="sr-only">Voltar ao início</span>
                </a>
                {menu ? <MenuResponsivo itens={menu as any} /> : <></>}
                <div className="min-w-0 flex-1" />
                {(() => {
                    if (categoria === 6 && diasAvaliacao > -1)
                        return (
                            <BoxAssinar href="/planos">
                                {(() => {
                                    switch (diasAvaliacao) {
                                        case 0:
                                            return 'Avaliação: Menos de um dia restante'
                                        case 1:
                                            return 'Avaliação: 1 dia restante'
                                        default:
                                            return `Avaliação: ${diasAvaliacao} dias restantes`
                                    }
                                })()}
                            </BoxAssinar>
                        )
                    else if (
                        user.decoded.isAtivo === false &&
                        ![1, 7].includes(categoria)
                    )
                        return (
                            <BoxAssinar href="/planos/me">
                                <b>Sua assinatura expirou!</b>
                            </BoxAssinar>
                        )
                })()}
                <ToggleTheme />
                <ProfileMenu />
            </div>
        </div>
    )
}

function BoxAssinar({
    children,
    href,
}: {
    children: React.ReactNode
    href: string
}) {
    const { decoded } = useAuth()

    const podeRedirecionar = [3, 6].includes(decoded?.categoria)

    return [
        <div
            key="desktop"
            className="hidden sm:flex items-center justify-end gap-2 w-[600px] mr-1"
        >
            <span className="text-sm text-center break-words">{children}</span>
            {podeRedirecionar && (
                <Button size="small" color="warning" href={href}>
                    Assinar
                </Button>
            )}
        </div>,
        <Button
            key="mobile"
            className="flex sm:hidden mr-1 max-h-full p-0 px-2 sm:p-2 text-center my-1"
            disabled={!podeRedirecionar}
            size="small"
            color="warning"
            href={href}
        >
            {children}
        </Button>,
    ]
}
